import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { ProfileService } from '../../services/profile.service';
import { PIDService } from '../../services/pid.service';
import { JobService } from '../../services/job.service';
import { FileTypeService } from '../../services/fileType.service';
import { NotificationService } from '../../services/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { SearchbarService } from '../../services/searchbar.service';
import { environment } from '../../environments/environment';


import * as _ from 'lodash';

class Item {
  name = {
    nl: '',
    fr: '',
    en: ''
  };

  isNew = true;
  mandatory = false;
}

@Component({
  selector: 'admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdministrationComponent implements OnInit {

  steps = [];
  templates = {
    newHouse: {
      villa: {},
      rowHouse: {},
      flat: {}
    },
    existingHouse: {
      villa: {},
      rowHouse: {},
      flat: {}
    },
    betterRenovate: {
      villa: {},
      rowHouse: {},
      flat: {}
    }
  };
  jobs = {
    all: [],
    display: []
  };
  fileTypes = {
    all: [],
    display: []
  };
  users = {
    all: [],
    display: []
  };
  pids = {
    all: [],
    display: []
  };
  types = [];
  pidTypes = ['normal', 'expired', 'shared', 'transferred', 'received'];
  expiredTypes = ['expired'];
  toEmail = null;

  setp = {};
  modal = {
    sendMessage: false
  };

  tabindex = 3;
  currentFilter = null;
  pidToDelete;
  pidToMod;
  profileToDelete;
  newOwner;

  oldPIDOwner;
  newPIDOwner;
  sysinfo = {};
  env = {};

  pidFilter = '';
  userFilter = '';
  pidExpiredFilter = -1;

  stringify(data) {
    return JSON.stringify(data);
  }

  constructor(private _notification: NotificationService, private _userService: UserService,
    private _profileService: ProfileService, private _router: Router, public translate: TranslateService,
    private _jobService: JobService, private _fileTypeService: FileTypeService, private _pidService: PIDService,
    private _searchService: SearchbarService) {
    this.steps.push({ name: ['Administration'], ref: ['admin', {}] });
  }

  ngOnInit() {


    if (!this._userService.isAdmin()) {
      this._router.navigate(['']);
    }

    this._userService.sysinfo().subscribe(sysinfo => {
      this.sysinfo = JSON.stringify(sysinfo, null, "    ");
      this.env = environment;
    });


    this._jobService.getAdmin().subscribe(
      (jobs: any) => {
        jobs.forEach(j => {
          this.jobs.all.push(j);
          this.jobs.display.push(j);
        });
      },
      err => {
        this._notification.errorServer(err);
      }
    );

    this._pidService.getAdminTemplates().subscribe(
      templates => {
        this.templates = _.merge(this.templates, templates);
      }
    );

    this._fileTypeService.getAdmin().subscribe(
      (fileTypes: any) => {
        fileTypes.forEach(j => {
          this.fileTypes.all.push(j);
          this.fileTypes.display.push(j);
        });
      },
      err => {
        this._notification.errorServer(err);
      }
    );

    this._userService.getUserRoles().subscribe(
      (roles: []) => {
        this.types = roles;
      },
      err => {
        this._notification.errorServer(err);
      }
    );

    this.loadUsers();
    this.loadPids();
  }

  formatDates(x){
    if (x.createdAt) x.createdAt = x.createdAt.split('T')[0];
    if (x.expires) x.expires = x.expires.split('T')[0];
    return x;
  }

  loadPids = () => {
    this._pidService.getAll(this.userFilter, this.pidExpiredFilter, this.currentFilter).subscribe(
      (pids: {}[]) => {
        pids = pids.map(x => this.formatDates(x));
        this.pids = { all: pids, display: pids };
        if (this.currentFilter) {
          this._searchService.filter(this.pids, this.currentFilter, [])
        }
      },
      err => {
        this._notification.errorServer(err);
      }
    );
  }

  loadUsers = () => {
    this._profileService.getAll(this.userFilter, this.pidFilter).subscribe(
      (users: []) => {
        this.users = { all: users, display: users };
        if (this.currentFilter) {
          this._searchService.filter(this.users, this.currentFilter, ['hashedPassword', 'salt', 'provider', 'lang', 'notifications'])
        }
      },
      err => {
        this._notification.errorServer(err);
      }
    );
  }

  canChangeRole(user) {
    return (user.role != 'admin');
  }

  isAdmin() {
    return this._userService.isAdmin();
  }

  addClick(tabs) {
    switch (tabs.selectedIndex) {
      case 0:
        this.addJob();
        break;
      case 1:
        this.addFileType();
        break;
      case 3:
        this.addUser();
        break;
      default:
        break;
    }
  }

  editUser(u) {
    console.log('u', u);
    this._userService.adminEdit(u).subscribe(
      uEdited => {
        this._notification.success('MESSAGE.SUCCESS', ' ');
        this.loadUsers();
      },
      err => {
        this._notification.errorServer(err);
      }
    );
  }

  editPid(u) {
    console.log('u', u);
    this._pidService.expires(u._id, u).subscribe(
      uEdited => {
        this._notification.success('MESSAGE.SUCCESS', ' ');
        this.loadPids();
      },
      err => {
        this._notification.errorServer(err);
      }
    );
  }

  addUser() {
    console.log('to do');
  }

  now(u) {
    u.createdAt = new Date().toISOString().split('T')[0];
  }

  addOneYear(u) {
    //console.log(u.expires);
    var d;
    try {
      d = new Date(u.createdAt);
      u.expires = new Date(d.getFullYear() + 1, d.getMonth(), d.getDate()).toISOString().split('T')[0];
    } catch (e) {
      d = new Date();
      u.expires = new Date(d.getFullYear() + 1, d.getMonth(), d.getDate()).toISOString().split('T')[0];
    }
  }

  impersonateUser(u) {
    this._userService.impersonate(u).subscribe(
      token => {
        this._router.navigate(['']);
      },
      err => {
        this._notification.errorServer(err);
      }
    );
  }

  startPasswordUser(u) {
    this.setp[u._id] = true;
    console.log(u, this.setp);
  }

  setPasswordUser(u) {
    this._userService.adminSetPassword(u).subscribe(
      uEdited => {
        this._notification.success('MESSAGE.SUCCESS', ' ');
        this.setp[u._id] = false;
      },
      err => {
        this._notification.errorServer(err);
      }
    );
  }


  private _saveCollection(service, collection) {
    service.addGlobal(collection.all).subscribe(
      errors => {
        if (errors.length == 0)
          this._notification.success('MESSAGE.UPDATE', 'MESSAGE.SUCCESS');
        else {
          this._notification.warning('MESSAGE.UPDATE', errors.length + ' errors');
        }
      },
      err => {
        this._notification.errorServer(err);
      }
    );
  }

  private _addToCollection(collection) {
    const newItem = new Item();
    collection.all.push(newItem);
    collection.display.push(newItem);
  }

  private _removeFromCollectionLocal(e, collection) {
    _.remove(collection.display, (elem) => {
      if (elem['_id'] && e._id) {
        return (elem['_id'] == e._id);
      }
      else {
        return (elem['name'].nl == e['name'].nl && elem['name'].fr == e['name'].fr && elem['name'].en == e['name'].en);
      }
    });
    _.remove(collection.all, (elem) => {
      if (elem['_id'] && e._id) {
        return (elem['_id'] == e._id);
      }
      else {
        return (elem['name'].nl == e['name'].nl && elem['name'].fr == e['name'].fr && elem['name'].en == e['name'].en);
      }
    });
  }

  private _removeFromCollection(e, collection, service) {
    if (e._id) {
      service.removeGlobal(e).subscribe(() => {
        this._removeFromCollectionLocal(e, collection);
      });
    } else {
      this._removeFromCollectionLocal(e, collection);
    }
  }

  userFilterChange(event) {
    console.log("user filter change", event.target.value);
    this.userFilter = event.target.value;
    this.loadUsers();
  }

  pidFilterChange(event) {
    console.log("pid filter change", event.target.value);
    this.pidFilter = event.target.value;
    this.loadUsers();
  }

  pidExpiredFilterChange(event) {
    console.log("pid expired filter change", event.target.value);
    this.pidExpiredFilter = event.target.value;
    this.loadPids();
  }

  saveTemplates() {
    this._pidService.saveAdminTemplates(this.templates).subscribe(
      templates => {
        this._notification.success('MESSAGE.SUCCESS', ' ');
        this.templates = _.merge(this.templates, templates);
      },
      err => {
        this._notification.errorServer(err);
      }
    );
  }

  removeJob(j) {
    this._removeFromCollection(j, this.jobs, this._jobService);
  }

  saveJobs() {
    this._saveCollection(this._jobService, this.jobs);
  }

  addJob() {
    this._addToCollection(this.jobs);
  }

  removeFileType(ft) {
    this._removeFromCollection(ft, this.fileTypes, this._fileTypeService);
  }

  saveFileTypes() {
    this._saveCollection(this._fileTypeService, this.fileTypes);
  }

  addFileType() {
    this._addToCollection(this.fileTypes);
  }

  sendMessageTo(email) {
    this.toEmail = email;
    this.modal.sendMessage = true;
  }

  modOwnerPID() {
    console.log("mod owner PID", this.pidToMod, this.newOwner);
    this._pidService.changeOwner(this.pidToMod, { profile: this.newOwner }).subscribe(x => {
      console.log("changed", x);
    });
  }

  switchOwnerPIDs() {
    console.log("switch owner PIDs", this.oldPIDOwner, this.newPIDOwner);
    this._pidService.switchOwner(this.oldPIDOwner, { profile: this.newPIDOwner }).subscribe(x => {
      console.log("switched", x);
    });
  }

  removePID() {
    console.log("pidToDelete", this.pidToDelete);
    this._pidService.delete(this.pidToDelete).subscribe(x => {
      console.log("deleted", x);
    });
  }

  removeProfile() {
    console.log("profileToDelete", this.profileToDelete);
    this._profileService.delete(this.profileToDelete).subscribe(x => {
      console.log("deleted", x);
    });
  }

  filterUser(tabGroup, filter) {
    this.currentFilter = filter;
    switch (tabGroup.selectedIndex) {
      case 0:
        this._searchService.filter(this.jobs, filter);
        break;
      case 1:
        this._searchService.filter(this.fileTypes, filter);
        break;
      case 2:
        this._searchService.filter(this.templates, filter);
        break;
      case 3:
        this._searchService.filter(this.users, filter, ['hashedPassword', 'salt', 'provider', 'lang', 'notifications']);
        break;
      case 4:
        this.loadPids();
        //console.log("filter user / pid", filter);
        break;
      default:
        break;
    }
  }
}
